"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link SetClientConflationFilterRequest}
 */
var SetClientConflationFilterRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(SetClientConflationFilterRequestSerialiserClass, _super);
    function SetClientConflationFilterRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SetClientConflationFilterRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link SetClientConflationFilterRequest} to be written
     */
    SetClientConflationFilterRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.filter);
        Codec.writeBoolean(bos, value.conflate);
    };
    return SetClientConflationFilterRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SetClientConflationFilterRequestSerialiserClass = SetClientConflationFilterRequestSerialiserClass;
/**
 * The {@link SetClientConflationFilterRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SetClientConflationFilterRequestSerialiser = new SetClientConflationFilterRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/set-client-conflation-filter-request-serialiser.js
// module id = 1916
// module chunks = 1